// src/services/goldApi.js

const API_URL = 'https://bcast.kakagold.xyz/VOTSBroadcastStreaming/Services/xml/GetLiveRateByTemplateID/kaka';
// kakasilverbar for silver
// Parse the tab-separated response
const parseGoldData = (text) => {
  const lines = text.split('\n').filter(line => line.trim());
  const products = [];
  
  lines.forEach(line => {
    const parts = line.split('\t').filter(p => p.trim());
    
    if (parts.length >= 6) {
      const id = parts[0].trim();
      const name = parts[1].trim();
      const currentPrice = parseFloat(parts[2]) || 0;
      const askPrice = parseFloat(parts[3]) || 0;
      const highPrice = parseFloat(parts[4]) || 0;
      const lowPrice = parseFloat(parts[5]) || 0;
      
      // Only include gold-related products
      if (name.includes('GOLD') || name.includes('gold')) {
        products.push({
          id: id,
          name: name,
          price: currentPrice,
          ask: askPrice,
          high: highPrice,
          low: lowPrice,
          unit: name.includes('SPOT') ? 'oz' : 'gram',
          source: 'KakaGold'
        });
      }
    }
  });
  
  return products;
};

// Fetch live gold rates
export const fetchGoldRates = async () => {
  try {
    const timestamp = new Date().getTime();
    const response = await fetch(`${API_URL}?_=${timestamp}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const text = await response.text();
    const products = parseGoldData(text);
    
    if (products.length === 0) {
      throw new Error('No gold products found in response');
    }
    
    return products;
  } catch (error) {
    console.error('Error fetching gold rates:', error);
    throw error;
  }
};

// Get specific gold product
export const getGoldSpot = async () => {
  const products = await fetchGoldRates();
  return products.find(p => p.name === 'GOLD SPOT');
};

// Get all gold products
export const getAllGoldProducts = async () => {
  return fetchGoldRates();
};